import { render, staticRenderFns } from "./OperationDetail.vue?vue&type=template&id=b9e8f7b0&scoped=true&"
import script from "./OperationDetail.vue?vue&type=script&lang=js&"
export * from "./OperationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperationDetail.vue?vue&type=style&index=0&id=b9e8f7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e8f7b0",
  null
  
)

export default component.exports